import React from "react";

class Label extends React.Component {
  render() {
    const {
      fontSize,
      fontWeight,
      color,
      opacity,
      textTransform,
      padding,
      lineHeight,
      textAlign,
      wordBreak, // New prop for word break
      isComponentToShow,
      ...otherProps
    } = this.props;

    return (
      <div
        style={{
          fontSize,
          fontWeight,
          color,
          opacity,
          textTransform,
          padding,
          lineHeight,
          textAlign,
          whiteSpace: "pre-line", // Preserve line breaks and spaces
          wordBreak: wordBreak || "normal", // Default to 'normal' if wordBreak prop is not provided
          ...otherProps,
        }}
        className="label"
      >
        {/* {typeof this.props.text === "string" ? this.props.text : ""}{" "} */}
        {isComponentToShow
          ? this.props.text
          : typeof this.props.text === "string"
            ? this.props.text
            : typeof this.props.text === "number"
              ? this.props.text
              : ""}
      </div>
    );
  }
}

export default Label;
